/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllMutatableEntitiesResponse } from '../../models/get-all-mutatable-entities-response';

export interface GetAllMutatableEntities$Params {
}

export function getAllMutatableEntities(http: HttpClient, rootUrl: string, params?: GetAllMutatableEntities$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllMutatableEntitiesResponse>> {
  const rb = new RequestBuilder(rootUrl, getAllMutatableEntities.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllMutatableEntitiesResponse>;
    })
  );
}

getAllMutatableEntities.PATH = '/v1/graphql/mutatableEntities';
